export default __webpack_public_path__ + "static/media/04b_gamemarkers.357f828b.png";